import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { StorySection } from '../components/StorySection';
import { SolutionSection } from '../components/SolutionSection';
import { FitSection } from '../components/FitSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <main className="min-h-screen bg-cream font-sans text-charcoal" data-id="element-155">
      <HeroSection data-id="element-156" />
      <StorySection data-id="element-157" />
      <SolutionSection data-id="element-158" />
      <FitSection data-id="element-159" />
      <OfferSection data-id="element-160" />
      <Footer data-id="element-161" />
    </main>;
}